const putInLocalStorage = (key: string, value: string) => {
  try {
    localStorage.setItem(key, value);
  } catch {}
};

export default putInLocalStorage;
